
import {Component, Vue} from 'vue-property-decorator';
import PageNavbar from "./PageNavbar.vue";
import PageFooter from "./PageFooter.vue";
import FastNavigationSidebar from "@/modules/sidebar/FastNavigationSidebar.vue";
import VersionUpdatedNotificationBar from "@/components/VersionUpdatedNotificationBar.vue";

@Component({
  components: {VersionUpdatedNotificationBar, FastNavigationSidebar, PageFooter, PageNavbar}
})
export default class PageLayout extends Vue {
  collapsed: boolean = false;
}
